import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import CommonHeader from '../../util_components/common_header';
import CustomModal from '../../util_components/custom_modal';
import CustomSingleSelect from '../../util_components/custom_single_select';
import CustomDatePicker from '../../util_components/custom_date_picker';

import { image_error_replace, get_date_filter_data_timezone_utc } from '../../../util_functions';
import {
  day_format,
  time_format,
  date_drop_for_report,
  EthnicityOptions
} from '../../../constants';
import { post_api, put_api } from '../../../redux/api_funcs';
import * as actions from '../../../redux/action_creators';
import { get_api_url } from '../../../utils/urls';
import SmsWindow from './sms_window';

import 'react-datepicker/dist/react-datepicker.css';
import { openChatWithUserUUID } from '../../chat/chat';
import UserRole from '../../../myt_chat/chat/enums/UserRole';
import { EditIcon } from '../../../utils/svg';
import CustomCheckbox from '../../util_components/custom_checkbox';
import { teacherFullNameOf } from '../../../utils/teacher_name';

// Inline so it beats the 20px `.ct-si img` rule; keeps onboarding secondary to Member.
const onboarding_icon_style = { width: '14px', height: '14px' };

class NewUsers extends Component {
  state = {
    loading: true,
    start_date: moment().format('YYYY-MM-DD'),
    end_date: moment().format('YYYY-MM-DD'),
    students: [],
    history: '',
    history_open: '',
    open_info: false,
    student_info: {},
    concierge_teachers: [],
    concierge_teacher_uuid: '',
    is_header_sticky: false,
    sms_window_open: false,
    sms_student: '',
    sms_student_name: '',
    open_ethnicity_popup: false,
    concierge_entered_ethnicity: '',
    message_dispatch_method: 'sms',
    selected_field: null
  };

  headerRef = React.createRef();

  async componentDidMount() {
    this.load_data();

    if (this.props.teachers_list_status === 'success') {
      this.set_teachers_list();
    }

    if (this.props.teachers_list_status === 'none') {
      this.props.get_teachers_list();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.teachers_list_status === 'loading' &&
      this.props.teachers_list_status === 'success'
    ) {
      this.set_teachers_list();
    }
  }

  handleFieldChange = (e) => {
    const { checked = false, name = '' } = e.target;

    this.setState({ selected_field: checked ? e.target.name : '' });
  };

  filter_required_fields = (students_list) => {
    const { selected_field = '' } = this.state;
    switch (selected_field) {
      case 'Phone Number':
        if (!students_list) return [];
        const filtered = students_list.filter((student) => student.phone_no !== null);
        return filtered;

      default:
        return students_list || [];
    }
  };

  handle_scroll = () => {};

  set_teachers_list = () => {
    const all_teachers = this.props.teachers_list.filter((t) => t.opt_in_concierge === 1);
    const teachers_list = all_teachers.map((teacher) => ({
      value: teacher.uuid,
      label: teacherFullNameOf(teacher)
    }));
    teachers_list.sort((a, b) => a.label.localeCompare(b.label));
    this.setState({ concierge_teachers: [{ value: 'all', label: 'ALL' }, ...teachers_list] });
  };

  load_data = () =>
    this.setState({ loading: true }, () => {
      const { date_filter_type, start_date, end_date } = this.state;
      const url = get_api_url('get_latest_students');
      const date_data = get_date_filter_data_timezone_utc(date_filter_type, start_date, end_date);

      const payload = {
        start_date: date_data.utc_start_date,
        end_date: date_data.utc_end_date,
        iana_timezone: this.props.iana_timezone
      };
      post_api(url, payload, true)
        .then((res) => {
          this.setState({ loading: false, students: [...res.data.student_data] });
        })
        .catch((e) => {
          let err_message;
          try {
            err_message = e.response.data.message;
          } catch (err) {
            err_message = 'Some error occured. Please contact dev team.';
          }
          this.props.set_notification_variable(true, 'error', err_message);
          this.setState({ loading: false });
        });
    });

  handle_date_chage = (date, component) => {
    this.setState({ [component]: date });
  };

  change_date_filter = (e) =>
    this.setState({ date_filter_type: e.target.value }, () => {
      if (this.state.date_filter_type !== 'CUSTOM') {
        this.load_data();
      }
    });

  handle_date_change = (name, val) => this.setState({ [name]: val });

  change_concierge = (e) => this.setState({ concierge_teacher_uuid: e.target.value });

  close_ethnicity_popup = () => {
    this.setState({
      open_ethnicity_popup: false
    });
  };

  open_ethnicity_popup = (student) => {
    this.setState({
      open_ethnicity_popup: true,
      student_info: student,
      concierge_entered_ethnicity: student.concierge_entered_ethnicity
    });
  };

  change_ethnicity_value = (e) => {
    e.preventDefault();
    this.setState({ concierge_entered_ethnicity: e.target.value });
  };

  submit_entered_ethnicity = async () => {
    this.setState({ loading: true });
    const url = get_api_url('/v2/cms_user/update_student_ethnicity', false, true);
    const payload = {
      student_uuid: this.state.student_info?.uuid,
      ethnicity: this.state.concierge_entered_ethnicity
    };
    try {
      await put_api(url, payload, true);
      this.setState({ loading: false });
      this.load_data();
      this.close_ethnicity_popup();
    } catch (e) {
      let err_message;
      try {
        err_message = e.response.data.message;
      } catch (err) {
        err_message = 'Some error occured. Please contact dev team.';
      }
      this.setState({ loading: false });
    }
  };

  render_change_ethnicity = () => (
    <>
      <CustomSingleSelect
        label="Ethnicity"
        options={EthnicityOptions}
        onChange={(e) => this.change_ethnicity_value(e)}
        value={this.state.concierge_entered_ethnicity}
        name="concierge_entered_ethnicity"
      />
      <button className="ct-small-btn" onClick={() => this.submit_entered_ethnicity()}>
        Submit
      </button>
    </>
  );

  render_filters = () => {
    const { date_filter_type, start_date, end_date, concierge_teachers, concierge_teacher_uuid } =
      this.state;

    return (
      <div className="flex flex-col">
        <div
          style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'center' }}
        >
          <div style={{ marginRight: '10px' }}>
            <CustomSingleSelect
              label="Select a date filter"
              options={date_drop_for_report}
              onChange={this.change_date_filter}
              value={date_filter_type}
              style={{ width: '200px' }}
            />
          </div>
          {this.state.date_filter_type === 'CUSTOM' ? (
            <>
              <div className="daily-report-item">
                <CustomDatePicker
                  label="Start Date"
                  value={start_date}
                  handleChange={(val) => this.handle_date_change('start_date', val)}
                  maxDate={end_date}
                />
              </div>
              <div className="daily-report-item">
                <CustomDatePicker
                  label="End Date"
                  value={end_date}
                  handleChange={(val) => this.handle_date_change('end_date', val)}
                  minDate={start_date}
                  maxDate={moment().format('YYYY-MM-DD')}
                />
              </div>
              <button onClick={this.load_data}>Submit</button>
            </>
          ) : null}
          <div style={{ marginRight: '10px' }}>
            <CustomSingleSelect
              label="Select a concierge"
              options={concierge_teachers}
              onChange={this.change_concierge}
              value={concierge_teacher_uuid}
              style={{ width: '200px' }}
              showClear
              clear_fn={this.clear_concierge}
            />
          </div>
        </div>

        <div className="self-center">
          <div style={{ marginRight: '10px' }}>
            <CustomCheckbox
              label="Filter students with phone number given"
              checked={!!this.state.selected_field}
              onClick={(e) => this.handleFieldChange(e)}
              name="Phone Number"
            />
          </div>
        </div>
      </div>
    );
  };

  clear_concierge = () => this.setState({ concierge_teacher_uuid: '' });

  open_history = (e, history) => {
    e.stopPropagation();
    this.setState({ history, history_open: true });
  };

  open_chat = async (student) => {
    openChatWithUserUUID(student.uuid, UserRole.STUDENT);
  };

  isTextPresent = (inputString) => {
    const trimmedString = inputString.trim();
    if (trimmedString.length > 0) {
      return inputString;
    }
    return 'Name not given';
  };

  render_single_student = (student) => {
    const student_url = `/studentprofile?id=${student.uuid}`;
    const teacher_url = `/teacherprofile?id=${student.teacher_uuid}`;
    const concierge_url = `/teacherprofile?id=${student.concierge_uuid}`;
    const client_domain = student.client_domain
      ? student.client_domain === 'lifestyle'
        ? ''
        : 'Lifetree Health'
      : '';
    const ethniCity =
      student.concierge_entered_ethnicity !== ''
        ? student.concierge_entered_ethnicity
        : student.ml_ethnicity;

    return (
      <div className="ct-row" key={student.uuid}>
        <div className="ct-col ct-hf ct-la ct-bw">
          <a className="link-no-dec" href={student_url} target="_blank" rel="noopener noreferrer">
            <div className="profile-img-name">
              <img src={student.profile_photo} onError={image_error_replace} alt="x" />
              {this.isTextPresent(student?.name)}
            </div>
            {student.yoga_level ? (
              <div
                style={{ fontSize: '10px', marginLeft: '42px' }}
              >{`(${student.yoga_level})`}</div>
            ) : null}
          </a>
          {student.health_history ? (
            <div
              className="div-link"
              style={{ marginLeft: '42px' }}
              onClick={(e) => this.open_history(e, student.health_history)}
            >
              History
            </div>
          ) : null}
          {client_domain === '' ? null : (
            <div className="bg-mytPurple px-2.5 py-1 w-fit text-white text-xs font-bold leading-3 rounded-lg mx-auto flex justify-center items-center">
              {client_domain}
            </div>
          )}
        </div>
        <div className="ct-col ct-hf ct-la flex items-center gap-2">
          {ethniCity}{' '}
          <span>
            <a onClick={() => this.open_ethnicity_popup(student)}>{EditIcon()}</a>
          </span>
        </div>
        <div className="ct-col ct-qf ct-vsm-font">
          {client_domain === '' ? (
            <a className="btn-link" onClick={() => this.open_chat(student)}>
              Chat
            </a>
          ) : null}
        </div>
        <div className="ct-col ct-hf ct-sm-font">
          <div>{moment(student.created_date).tz(this.props.iana_timezone).format(day_format)}</div>
          <div>{moment(student.created_date).tz(this.props.iana_timezone).format(time_format)}</div>
        </div>
        <div className="ct-col ct-qf ct-sm-font  ct-si">
          {student.is_member === 1 ? (
            <img src="https://images.myyogateacher.com/icons/ic-checkmark-48.png" alt="av" />
          ) : (
            <img src="https://images.myyogateacher.com/icons/ic-delete-48.png" alt="nav" />
          )}
          <div className="mt-1">
            {student.onboarding_completed === 1 ? (
              <img
                src="https://images.myyogateacher.com/icons/ic-checkmark-48.png"
                alt="onboarded"
                style={onboarding_icon_style}
              />
            ) : (
              <img
                src="https://images.myyogateacher.com/icons/ic-delete-48.png"
                alt="not onboarded"
                style={onboarding_icon_style}
              />
            )}
          </div>
        </div>
        <div className="ct-col ct-hf ct-vsm-font ct-bw">
          <div>{student.funnel_url}</div>
          <div>{student.funnel_type}</div>
          <div>{student.offer_type}</div>
        </div>
        <div className="ct-col ct-qf ct-la ct-vsm-font">
          {student.concierge_uuid ? (
            <a className="link-no-dec" href={concierge_url}>
              <div className="profile-img-name">
                <img src={student.concierge_photo} onError={image_error_replace} alt="x" />
                {student.concierge_name}
              </div>
            </a>
          ) : (
            student.concierge_name
          )}
        </div>
        <div className="ct-col ct-hf ct-sm-font">
          <div className="new-users-sess-count">
            <div>
              {student.yoga_sessions_finshed > 0 ? (
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`/usersessions/past?id=${student.uuid}&user_type=STUDENT&name=${student.name}`}
                >
                  {student.yoga_sessions_finshed}
                </a>
              ) : (
                student.yoga_sessions_finshed
              )}
            </div>
            <div>
              {student.group_sessions_finshed > 0 ? (
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`/usersessions/past?id=${student.uuid}&user_type=STUDENT&name=${student.name}`}
                >
                  {student.group_sessions_finshed}
                </a>
              ) : (
                student.group_sessions_finshed
              )}
            </div>
          </div>
        </div>
        <div className="ct-col ct-hf ct-sm-font">
          <div className="new-users-sess-count">
            <div>
              {student.yoga_sessions_scheduled > 0 ? (
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`/usersessions/future?id=${student.uuid}&user_type=STUDENT&name=${student.name}`}
                >
                  {student.yoga_sessions_scheduled}
                </a>
              ) : (
                student.yoga_sessions_scheduled
              )}
            </div>
            <div>
              {student.group_sessions_scheduled > 0 ? (
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`/usersessions/future?id=${student.uuid}&user_type=STUDENT&name=${student.name}`}
                >
                  {student.group_sessions_scheduled}
                </a>
              ) : (
                student.group_sessions_scheduled
              )}
            </div>
          </div>
        </div>
        <div className="ct-col ct-qf ct-sm-font">{student.credits}</div>
        <div
          className="ct-col ct-qf ct-sm-font ct-si"
          style={{ cursor: 'pointer' }}
          onClick={() => this.setState({ open_info: true, student_info: student })}
        >
          <img src="https://images.myyogateacher.com/icons/ic_info_blue.png" />
        </div>
        <div className="ct-col ct-qf ct-sm-font  ct-si">
          {student.to_student == 1 ? (
            <img src="https://images.myyogateacher.com/icons/ic-checkmark-48.png" alt="av" />
          ) : student.to_student == 0 ? (
            <img src="https://images.myyogateacher.com/icons/ic-delete-48.png" alt="nav" />
          ) : student.to_student === null ? (
            <span>--</span>
          ) : null}
        </div>
        <div className="ct-col ct-qf">
          {!!student.phone_no &&
          student.phone_no != '' &&
          student.message_dispatch_method !== 'none' ? (
            <button
              className={`ct-small-btn ${student.message_dispatch_method === 'whatsapp' ? 'wa-btn' : ''}`}
              onClick={() => this.open_sms_window(student)}
            >
              {student.message_dispatch_method === 'sms'
                ? 'Send SMS'
                : student.message_dispatch_method === 'whatsapp'
                  ? 'Send WA'
                  : null}
            </button>
          ) : null}
        </div>
      </div>
    );
  };

  get_href = (uuid, type) => {
    let final_href = null;
    if (type === 'YOGA') {
      final_href = `/sessiondetails?id=${uuid}`;
    } else {
      final_href = `/groupsessiondetails?session_uuid=${uuid}`;
    }
    return final_href;
  };

  get_excel_data = () => {
    const { students } = this.state;
    const teacherDataArr = [];
    students.forEach((item) => {
      const csvData = {
        name: item?.name,
        uuid: item?.uuid,
        created_date: moment(item?.created_date)
          .tz(this.props.iana_timezone)
          .format('YYYY-MM-DD HH:mm:ss z'),
        funnel_url: item?.funnel_url,
        offer_type: item?.offer_type,
        funnel_type: item?.funnel_type,
        device_type: item?.device_type,
        yoga_level: item?.yoga_level,
        trial_end_date: moment(item?.trial_end_date)
          .tz(this.props.iana_timezone)
          .format('YYYY-MM-DD HH:mm:ss z'),
        affiliate: item?.affiliate,
        queue_affiliate: item?.queue_affiliate,
        credits: item?.credits,
        concierge_name: item?.concierge_name,
        is_member: item?.is_member,
        phone_personal: item?.phone_personal,
        yoga_sessions_finshed: item?.yoga_sessions_finshed,
        group_sessions_finshed: item?.group_sessions_finshed,
        yoga_sessions_scheduled: item?.yoga_sessions_scheduled,
        group_sessions_scheduled: item?.group_sessions_scheduled,
        client_domain: item?.client_domain
      };
      teacherDataArr.push('csvData', csvData);
    });
    return teacherDataArr;
  };

  render_data = () => {
    const { students, concierge_teacher_uuid, is_header_sticky, selected_field } = this.state;
    let filter_students = [...students];
    if (concierge_teacher_uuid) {
      filter_students = students.filter((s) => {
        if (concierge_teacher_uuid === 'all') {
          return !!s.concierge_uuid;
        }
        return s.concierge_uuid === concierge_teacher_uuid;
      });
    }

    if (selected_field) {
      filter_students = this.filter_required_fields(filter_students);
    }
    return (
      <div className="cus-table">
        <div className={`ct-row ct-h ${is_header_sticky ? 'cus-sticky' : ''}`} ref={this.headerRef}>
          <div className="ct-col ct-hf ct-la">Name</div>
          <div className="ct-col ct-hf ct-la">Ethnicity</div>
          <div className="ct-col ct-qf ct-sm-font">Chat</div>
          <div className="ct-col ct-hf ct-sm-font">Created Date</div>
          <div className="ct-col ct-qf ct-sm-font">
            <div>Member</div>
            <div>(Onboarding)</div>
          </div>
          <div className="ct-col ct-hf ct-sm-font">
            <div>Funnel Url</div>
            <div>Source</div>
            <div>Offer</div>
          </div>
          <div className="ct-col ct-qf ct-sm-font ct-la">Concierge</div>
          <div className="ct-col ct-hf ct-vsm-font">
            <div>Session - Fin</div>
            <div>1on1 | GROUP</div>
          </div>
          <div className="ct-col ct-hf ct-vsm-font">
            <div>Session - SCH</div>
            <div>1on1 | GROUP</div>
          </div>
          <div className="ct-col ct-qf ct-sm-font">Credits</div>
          <div className="ct-col ct-qf ct-sm-font">Info</div>
          <div className="ct-col ct-qf ct-sm-font">Reply Sent</div>
          <div className="ct-col ct-qf ct-sm-font" />
        </div>
        {filter_students.map(this.render_single_student)}
      </div>
    );
  };

  close_history = () => this.setState({ history_open: false, open_info: false, student_info: {} });

  open_sms_window = (student) => {
    this.setState({
      sms_window_open: true,
      sms_student: student.uuid,
      sms_student_name: student.name,
      message_dispatch_method: student.message_dispatch_method,
      is_allowed_whatsapp: student.is_allowed_whatsapp,
      is_allowed_sms: student.is_allowed_sms
    });
  };

  on_reply_sent = () => {
    const { students, send_sms_uuid, sms_student } = this.state;
    const new_students_data = [...students];
    const student = new_students_data.find((s) => s.uuid === sms_student);
    if (student) {
      student.to_student = 1;
      this.setState({ students: new_students_data });
    }
  };

  close_sms_window = () => this.setState({ sms_window_open: false, sms_student: '' });

  render_info = () => {
    const { student_info } = this.state;
    return (
      <div>
        <p>Name - {student_info.name}</p>
        <p>Affiliate - {student_info.affiliate}</p>
        <p>Queue Table Affiliate - {student_info.queue_affiliate}</p>
        <p>
          Trial End -{' '}
          {moment(student_info.trial_end_date).tz(this.props.iana_timezone).format(day_format)}{' '}
          {moment(student_info.trial_end_date).tz(this.props.iana_timezone).format(time_format)}
        </p>
      </div>
    );
  };

  render() {
    const {
      loading,
      history_open,
      history,
      open_info,
      sms_window_open,
      sms_student,
      sms_student_name,
      open_ethnicity_popup,
      message_dispatch_method,
      is_allowed_whatsapp,
      is_allowed_sms
    } = this.state;
    return (
      <CommonHeader loading={loading} title="New Users">
        <CustomModal show={history_open} close={this.close_history}>
          <div>{history}</div>
        </CustomModal>
        <CustomModal show={open_info} close={this.close_history}>
          {this.render_info()}
        </CustomModal>
        <div style={{ minHeight: '400px' }}>
          {this.render_filters()}
          {this.render_data()}
        </div>
        {sms_window_open ? (
          <SmsWindow
            student_uuid={sms_student}
            student_name={sms_student_name}
            close_fn={this.close_sms_window}
            send_success_notification={this.on_reply_sent}
            message_dispatch_method={message_dispatch_method}
            is_allowed_sms={is_allowed_sms}
            is_allowed_whatsapp={is_allowed_whatsapp}
          />
        ) : null}
        <CustomModal show={open_ethnicity_popup} close={this.close_ethnicity_popup}>
          {this.render_change_ethnicity()}
        </CustomModal>
      </CommonHeader>
    );
  }
}

const mapStateToProps = (state) => ({
  iana_timezone: state.home.iana_timezone,
  teachers_list: state.teachers.teachers_list,
  teachers_list_status: state.teachers.teachers_list_status
});

const mapDispatchToProps = (dispatch) => ({
  get_teachers_list: (status) => {
    dispatch(actions.get_teachers_list(status));
  },
  set_notification_variable: (show, type, mes) => {
    dispatch(actions.set_notification_variable(show, type, mes));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(NewUsers);
